"use strict";

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _nullishCoalesce(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}

var _chunkNESC3UD7js = require('./chunk-NESC3UD7.js');

var _chunk6R5OOOHCjs = require('./chunk-6R5OOOHC.js');

var _chunkR4XHR6A7js = require('./chunk-R4XHR6A7.js');

var d = {
  ExtraSmall: 14,
  Large: 44,
  Medium: 30,
  Small: 20
};

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var f = _styledcomponents2.default.svg(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var _react = require('react');

var _jsxruntime = require('react/jsx-runtime');

var v = _styledcomponents2.default.call(void 0, f)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    ", "\n"])), _chunkNESC3UD7js.e, function (_ref) {
  var o = _ref.$color,
      i = _ref.$hoverColor,
      e = _ref.$px,
      n = _ref.$svgElements,
      r = _ref.theme;
  return _styledcomponents.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        width: ", "px;\n        height: ", "px;\n        min-width: ", "px;\n        min-height: ", "px;\n        max-width: ", "px;\n        max-height: ", "px;\n\n        ", " {\n            fill: ", ";\n        }\n\n        ", "\n    "])), e, e, e, e, e, e, n.join(","), o === "inherit" ? "currentColor" : _chunkR4XHR6A7js.a.call(void 0, r.color.icon, o), i && _styledcomponents.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            :hover {\n                cursor: pointer;\n                ", " {\n                    fill: ", ";\n                }\n            }\n        "])), n.join(","), _chunkR4XHR6A7js.a.call(void 0, r.color.icon, i)));
}),
    x = exports.b = ["active", "critical", "decorative.alt", "decorative.default", "decorative.light", "default", "disabled", "hover", "info", "inverse", "primary.alt.active", "primary.alt.default", "primary.alt.hover", "primary.default", "success", "warning.default", "warning.light"],
    w = ["inherit"];

function V(o) {
  var i = _chunk6R5OOOHCjs.g.call(void 0, o.name),
      n = _react.forwardRef.call(void 0, function (_ref2, C) {
    var r = _ref2.color,
        I = _ref2.hoverColor,
        c = _ref2.IGNORECHECKS,
        y = _objectWithoutProperties(_ref2, ["color", "hoverColor", "IGNORECHECKS"]);

    var t = d[o.size],
        p = _nullishCoalesce(_chunk6R5OOOHCjs.b.call(void 0, x, o.name, r, "icon", c, w), function () {
      return "inherit";
    });

    return _jsxruntime.jsxs.call(void 0, v, _objectSpread({
      $color: p,
      $hoverColor: _chunk6R5OOOHCjs.b.call(void 0, x, o.name, I, "icon", c),
      $px: t,
      $svgElements: o.svgElements,
      "data-testid": i,
      fill: "none",
      height: t,
      ref: C,
      role: "none",
      viewBox: "0 0 ".concat(t, " ").concat(t),
      width: t,
      xmlns: "http://www.w3.org/2000/svg"
    }, y, {
      children: [o.conditionallyAddChildrenByColor ? o.conditionallyAddChildrenByColor(p) : null, o.svg]
    }));
  });

  return n.displayName = o.name, n.defaultTestId = i, n.size = o.size, n;
}

exports.a = f;
exports.b = x;
exports.c = V;